// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dt-2";
export var aiChatCartContainerExit = "_dt-4";
export var aiChatContainerLarge = "_dt-0";
export var aiChatContainerSmall = "_dt-1";
export var aiChatIcon = "_dt-6";
export var slideInFromRight = "_dt-3";
export var slideOutToRight = "_dt-5";